import React from "react";
import { Col, Typography } from "antd";

const { Title } = Typography;
function RegisterForm() {
  return (
    <>
      <Col lg={12} md={24} className="login-left-content p-4">
        <div className="registerPageContent" style={{ paddingLeft: "30px", paddingRight: "20px" }}>
          <p>foodflow</p>
          <Title
            style={{
              color: "white",
              fontWeight: "500",
              marginBottom: 4,
            }}
            level={4}
            className="Primary-Font"
          >
            The Cherry on top for your
            <br /> stock, allergens & safety management
          </Title>
          <p>
            One system to manage all of your food processes
            <br />
            system with FoodFlow.co
          </p>
        </div>
      </Col>
    </>
  );
}

export default RegisterForm;
